
import { Card } from "@/api/dtos/Card.schema";
import { StationSummary } from "@/api/dtos/StationSummary.schema";
import { Component, Prop, Vue } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
  },
})
export default class CardsOverview extends Vue {
  @Prop()
  readonly cards!: Card[];

  readonly headers: {
    text: string;
    value: string;
    align?: "start" | "center" | "end";
  }[] = [
    {
      text: "Kartenname",
      value: "name",
    },
    {
      text: "Servicekarte",
      value: "isServiceCard",
      align: "center",
    },
  ];
}
